import { Box, Card, CardContent, Skeleton } from "@mui/material";

export const StatCardSkeleton = () => (
    <Card elevation={1} sx={{ borderRadius: 2, height: 180 }}>
        <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Box display="flex" alignItems="center" gap={2}>
                <Box flex={1}>
                    <Skeleton variant="text" width="60%" height={30} />  {/* Title */}
                    <Skeleton variant="text" width="100%" height={20} /> {/* Subtitle */}
                </Box>
                <Skeleton variant="circular" width={40} height={40} />   {/* Icon */}
            </Box>

            <Box mt={2}>
                <Skeleton variant="text" width="50%" height={32} /> {/* Count */}
            </Box>

            <Box mt={1}>
                <Skeleton variant="rectangular" width="40%" height={30} sx={{ borderRadius: 1 }} /> {/* View more button */}
            </Box>
        </CardContent>
    </Card>
);